import PermissionService from '@Services/PermissionService';
import React, { lazy } from 'react';
const TransactionsList = lazy(() => import('./components/TransactionsList/TransactionsList'));
const Transaction = lazy(() => import('./components/Transaction/Transaction'));

export const transactionsConfig = [
	{
		auth: true,
		component: <Transaction />,
		name: 'transaction',
		path: '/transactions/:id',
		pm: (pm) => PermissionService(pm).getOrder(),
	},
	{
		auth: true,
		component: <TransactionsList />,
		name: 'transactions',
		path: '/transactions',
		pm: (pm) => PermissionService(pm).getOrders(),
	},
]